module.exports = __webpack_public_path__ + "img/beer_id-55.65c50ff4.png";